import { render, staticRenderFns } from "./CurrentUser.vue?vue&type=template&id=52b325c5&lang=pug&"
import script from "./CurrentUser.vue?vue&type=script&lang=js&"
export * from "./CurrentUser.vue?vue&type=script&lang=js&"
import style0 from "./CurrentUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b325c5')) {
      api.createRecord('52b325c5', component.options)
    } else {
      api.reload('52b325c5', component.options)
    }
    module.hot.accept("./CurrentUser.vue?vue&type=template&id=52b325c5&lang=pug&", function () {
      api.rerender('52b325c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobileFSFB/components/CurrentUser.vue"
export default component.exports